// extracted by mini-css-extract-plugin
export default {"modalWindowCenter":"modal-center_modalWindowCenter__zspf7"};